<em class="{{ fileIcon }}"></em>
